import StoreName           from '../../Shared/Constants/StoreName';
import IPlayerState        from '../../Shared/Interfaces/IPlayerState';

import Captions               from './Captions';
import ICaptions              from './Interfaces/ICaptions';
import ICaptionsStore         from './Interfaces/ICaptionsStore';
import resolveCaptionsActions from './resolveCaptionsActions';

const createCaptionsStore = (
    state: IPlayerState,
    initialValue: ICaptions = {}
): ICaptionsStore => {
    return state.createStore({
        name: StoreName.CAPTIONS,
        model: Captions,
        actions: resolveCaptionsActions,
        containsNestedProps: true
    }, initialValue);
};

export default createCaptionsStore;